import PropTypes from 'prop-types'
import { useState, useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import { toast } from 'react-toastify'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { CarritoContext } from '../context/carritoContext'
import Precios from '../reutilizables/precios/Precios'
import { SumarProductos } from '../reutilizables/sumarProductos/SumarProductos'
import * as listaEnvioService from '../servicios/listaEnvioService'
import * as presupuestosService from '../servicios/presupuestosService'
import * as publicacionesService from '../servicios/publicacionesService'
import LinkButton from '../ui/LinkButton'
import Carousel from './carousel/Carousel'
import styles from './DetalleCabecera.module.css'
import Medios from './Medios'

const DetalleCabecera = ({ detalle = {}, esVentas, permiteComprar = true }) => {
  const [ShowModal, setShowModal] = useState(false)
  const [ShowModalMsg, setShowModalMsg] = useState(false)
  const [pregunta, setPregunta] = useState('')
  const [envioDatos, setEnvioDatos] = useState(null)
  const [listaEnvios, setListaEnvios] = useState([])

  useEffect(() => {
    if (detalle.idPublicacion) {
      publicacionesService
        .obtenerEnvioDatosPorPublicacion(detalle.idPublicacion)
        .then(({ data }) => setEnvioDatos(data))
        .catch(() => setEnvioDatos(null))
    }
  }, [detalle.idPublicacion])

  useEffect(() => {
    if (detalle.idVendedor) {
      listaEnvioService
        .buscarListaPorVendedor(detalle.idVendedor, detalle.idPublicacion)
        .then(({ data }) => setListaEnvios(data))
        .catch(() => setListaEnvios([]))
    }
  }, [detalle.idVendedor, detalle.idPublicacion])
  const porcDcto = Number(detalle.porcDcto) || 0

  const {
    onAgregarCarrito,
    setVerCarrito,
    setIdPublicacionComprar,
    setIdPresupuestoComprar,
    setCantidadCompra,
    cantidadCompra,
    setPrecioUnitario
  } = useContext(CarritoContext)

  useEffect(() => {
    let precioFinal = detalle.precioUnitario

    if (porcDcto > 0) {
      precioFinal = detalle.precioUnitario * (1 - porcDcto / 100)
    }

    setPrecioUnitario(precioFinal)
  }, [detalle.precioUnitario, detalle.porcDcto, setPrecioUnitario])

  const handleClose = () => {
    setShowModal(false)
    setShowModalMsg(false)
  }
  const onSubmit = async (e) => {
    try {
      const presupuesto = {
        idUsuario: parseInt(localStorage.getItem('idUsuario')),
        idPublicacion: parseInt(detalle.idPublicacion),
        primerMensaje: pregunta
      }
      e.preventDefault()
      setShowModal(false)
      await presupuestosService.insertar(presupuesto)
      setPregunta('')
      setShowModalMsg(true)
    } catch (error) {
      const mensaje = `Ocurrió un error al grabar el presupuesto.`
      toastErrorLog(error, mensaje, 'presupuestos')
    }
  }

  const agregarItemCarrito = async (idPub) => {
    setVerCarrito(true)
    const respuesta = await onAgregarCarrito(idPub, cantidadCompra)

    setCantidadCompra(1)

    if (respuesta) {
      toast.success('Producto agregado al carrito correctamente!', {
        toastId: 'accion-ok'
      })
    } else {
      toast.error('Hubo un error al agregar el producto', {
        toastId: 'accion-error'
      })
    }
  }

  const setIdPublicacionSel = (idPub, cantidad) => {
    setIdPresupuestoComprar(0)

    let precioFinal = detalle.precioUnitario

    if (detalle.preciosMayorista && detalle.preciosMayorista.length > 0) {
      const preciosMayoristasOrdenados = [...detalle.preciosMayorista].sort(
        (a, b) => b.cantidad - a.cantidad
      )
      const precioAplicable = preciosMayoristasOrdenados.find((p) => cantidad >= p.cantidad)

      if (precioAplicable) {
        precioFinal = precioAplicable.precio
      }
    }

    if (porcDcto > 0) {
      precioFinal = precioFinal * (1 - porcDcto / 100)
    }

    setPrecioUnitario(precioFinal)
    setIdPublicacionComprar(idPub)
  }

  const setCantidadElementos = (cantidad) => {
    const bounded = Math.max(1, Math.min(cantidad, detalle.cantDisponible))
    setCantidadCompra(bounded)
  }
  const agregarAlCarrito = () => {
    agregarItemCarrito(detalle.idPublicacion)
  }

  const incrementar = (e) => {
    e.stopPropagation()
    setCantidadCompra((prev) => (prev < detalle.cantDisponible ? prev + 1 : prev))
  }

  const decrementar = (e) => {
    e.stopPropagation()
    setCantidadCompra((prev) => (prev > 1 ? prev - 1 : 1))
  }

  return (
    <>
      <div className="row">
        <div className="col-11 col-xl-6 contenedor-img-detalle">
          <Carousel detalle={detalle} />
        </div>
        <div className="col-5">
          <div className={styles.containerDetalle}>
            <Precios
              precio={detalle.precioUnitario}
              monedaSimbolo={detalle.monedaSimbolo}
              alicuota={detalle.alicuota}
              showSinIVA={true}
              className={styles.precioCabecera}
              mostrarDescuento={porcDcto > 0}
              porcDcto={porcDcto}
            />
            {((detalle.idPedidoItem && detalle.vendedorNombre && !esVentas) ||
              detalle.publicacionEstado === null) && <h3>Vendedor: {detalle.vendedorNombre}</h3>}
            <p>{detalle.titulo}</p>
            {detalle.categorias && <p>Categoría: {detalle.categorias}</p>}
            {detalle.cantidad && <p>Cantidad: {detalle.cantidad}</p>}
            <div>
              {detalle.preciosMayorista &&
                detalle.preciosMayorista.map((r) => (
                  <div key={r.idPublicacionPrecioMayorista}>
                    <Precios
                      nombre={`+${r.cantidad} ${r.unidad}`}
                      precio={r.precio}
                      monedaSimbolo={detalle.monedaSimbolo}
                      alicuota={detalle.alicuota}
                      showSinIVA={true}
                      mostrarDescuento={porcDcto > 0}
                      porcDcto={porcDcto}
                      className={styles.precioMayorista}
                    />
                  </div>
                ))}
            </div>
            {detalle.publicacionEstado !== null &&
              (detalle.conPresupuesto ? (
                <button className="btn btn-agregar-carrito" onClick={() => setShowModal(true)}>
                  Pedir Presupuesto
                </button>
              ) : permiteComprar ? (
                <div>
                  {detalle.mediosPagos && (
                    <Medios data={detalle?.mediosPagos} titulo="Medios de Pago" />
                  )}
                  {detalle.mediosEnvios && (
                    <div>
                      <Medios
                        data={detalle?.mediosEnvios}
                        titulo="Medios de Envío"
                        listaEnvios={listaEnvios}
                        envioDatos={envioDatos}
                      />
                    </div>
                  )}

                  {detalle.cantDisponible > 0 ? (
                    <div className={styles.flexContainer}>
                      <SumarProductos
                        cantidad={cantidadCompra}
                        setCantidad={setCantidadElementos}
                        decrementar={decrementar}
                        incrementar={incrementar}
                        cantDisponible={detalle.cantDisponible}
                        agregarAlCarrito={agregarAlCarrito}
                      />

                      <LinkButton
                        className="btn btn-primary btn-comprar"
                        to={{ pathname: '/compraDirecta', state: { detalle } }}
                        onClick={() => setIdPublicacionSel(detalle.idPublicacion, cantidadCompra)}
                      >
                        Comprar Ahora
                      </LinkButton>
                    </div>
                  ) : (
                    <p className={styles.sinStock}>SIN STOCK</p>
                  )}
                </div>
              ) : null)}
            <Modal show={ShowModal} onHide={handleClose} size={'lg'} animation={false}>
              <form onSubmit={onSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title>
                    <h3>Iniciar Presupuesto</h3>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <span>Estás por iniciar un presupuesto con tu contraparte.</span>
                  <p>
                    Si aceptás ahora, podrán intercambiar mensajes y definir los detalles para una
                    posible compra.
                  </p>
                  <p className="fw-semibold mt-3">
                    Si estás seguro, podés enviarle un mensaje al vendedor:
                  </p>
                  <textarea
                    name="pregunta"
                    className="text-area"
                    cols="35"
                    rows="6"
                    placeholder="Pregúntale algo al vendedor"
                    value={pregunta}
                    required
                    onChange={(e) => setPregunta(e.target.value)}
                  ></textarea>
                </Modal.Body>
                <Modal.Footer>
                  <div className={styles.modalFooter}>
                    <button type="button" className="btn btn-enviar" onClick={handleClose}>
                      Cancelar
                    </button>
                    <button type="submit" className="btn btn-volver-comprar">
                      Iniciar Presupuesto
                    </button>
                  </div>
                </Modal.Footer>
              </form>
            </Modal>
            <Modal show={ShowModalMsg} onHide={handleClose} size={'lg'} animation={false}>
              <Modal.Header closeButton>
                <Modal.Title>
                  <h3>Presupuesto iniciado</h3>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>Hemos enviado tu pregunta al vendedor.</p>
                {'Para consultar tu presupuesto, debes ir al menu Compras>Presupuestos'}
              </Modal.Body>
              <Modal.Footer>
                <button type="button" className="btn btn-enviar" onClick={handleClose}>
                  Aceptar
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </>
  )
}

export default DetalleCabecera

DetalleCabecera.propTypes = {
  detalle: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired,
    titulo: PropTypes.string.isRequired,
    categorias: PropTypes.string,
    monedaSimbolo: PropTypes.string,
    precioUnitario: PropTypes.number,
    preciosMayorista: PropTypes.arrayOf(
      PropTypes.shape({
        idPublicacionPrecioMayorista: PropTypes.number.isRequired,
        cantidad: PropTypes.number,
        unidad: PropTypes.string,
        precio: PropTypes.number
      })
    ),
    conPresupuesto: PropTypes.bool,
    mediosPagos: PropTypes.array,
    mediosEnvios: PropTypes.array,
    cantDisponible: PropTypes.number.isRequired
  }).isRequired,
  esVentas: PropTypes.bool.isRequired,
  permiteComprar: PropTypes.bool
}
